/**
 * @constructor
 *
 * @param $q
 * @param $timeout
 */
const PrintPrintDriver = function (
    $q,
    $timeout
) {
    this.$q = $q;
    this.$timeout = $timeout;
};

PrintPrintDriver.prototype = {
    /**
     * @param {Window} frame
     * @param {PrintJobOptions} opts
     *
     * @return {promise|jQuery.promise|*|{then, catch, finally}}
     */
    print: function (frame, opts) {
        let deferred = this.$q.defer();

        frame.focus();
        if (opts && typeof opts.onBeforePrintCall === 'function') {
            opts.onBeforePrintCall();
        }

        // Chrome needs a little time to load remote images but in any case PrinterApp and ProPoint Agent require base64
        // encoded images anyway. But if we did want to we would need this.
        // this.$timeout(function () {
        //    frame.print();
        // }, 750);
        frame.print();
        window.focus();

        this.$timeout(function () {
            // Give it a second to finish printing.
            // This timeout is necessary to prevent calling window.print() too quickly after the last call,
            // resulting in things not printing. 500ms seems to work in dev but still is too fast for client devices.
            // 1000ms (1s) should work for clients.
            deferred.resolve();
        }, 1500);

        return deferred.promise;
    },
};

module.exports = PrintPrintDriver;
